import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showSnackBar, hideSnackBar } from '../../../redux/Slices/snackbarSlice';
import { fetchBoardById } from '../../../redux/Slices/boardSlice';
import { config } from '../../../config';

const Screens = ({ activeLabel, setActiveLabel, activeScreen, setActiveScreen, handleBack, screenHistory, setScreenHistory }) => {
    const dispatch = useDispatch();
    const { board } = useSelector((state) => state.board);

    // Function to navigate to a screen
    const handleItemClick = (screen, label) => {
        // Update history and navigate to the new screen
        setScreenHistory([...screenHistory, { screen: activeScreen, label: activeLabel }]);
        setActiveScreen(screen);
        setActiveLabel(label);
    };

    const hasBackground = !!board?.cover?.url;

    const handleRemoveBackground = async () => {
        if (!hasBackground) return;

        dispatch(showSnackBar({ message: 'Removing background...', type: 'uploading' }));

        try {
            const response = await fetch(`${config.API_URI}/v1/boards/${board.shortId}/background`, {
                method: 'DELETE',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                credentials: 'include',
            });

            if (!response.ok) throw new Error('Failed to remove background');

            // Immediately clear the DOM CSS variable so BoardWrapper can re-apply cleanly later
            const mainEl = document.querySelector('main.app-content');
            mainEl?.style.removeProperty('--background-url');

            dispatch(fetchBoardById(board.shortId));
            dispatch(hideSnackBar());
        } catch (error) {
            console.error('Error removing background:', error);
            dispatch(showSnackBar({ message: 'Failed to remove background', type: 'error' }));
        }
    };

    // Sub-screens content
    const renderScreenContent = () => {
        return (
            <div className="add-attachment">
                <div className="group">
                    <div className="unsplash-images background-image-screens">
                        <div className="board-background-select" onClick={() => {
                            handleItemClick('Photos');
                            setActiveLabel('Photos');
                        }}>
                            <span className="background-box photos">Photos</span>
                        </div>
                        <div className="board-background-select" onClick={() => {
                            handleItemClick('Colors');
                            setActiveLabel('Colors');
                        }}>
                            <span className="background-box colors">Colors</span>
                        </div>
                        <div className="board-background-select" onClick={() => {
                            handleItemClick('Custom');
                            setActiveLabel('Custom');
                        }}>
                            <span className="background-box custom">Custom</span>
                        </div>
                        <div className={`board-background-select${!hasBackground ? ' selected' : ''}`} onClick={handleRemoveBackground}>
                            <span className="background-box no-background">
                                <span className="material-symbols-outlined">block</span>
                                None
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    return (
        <div className="screens-container">
            {/* Render screen content */}
            {renderScreenContent()}
        </div>
    );
};

export default Screens;
